import {charcoal} from '../../sass/v2/_exports.sass';

export const CrownIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9587 4.49999L10.6667 9.86532L6.37467 4.49999C6.20131 4.2857 5.96593 4.13027 5.70077 4.05501C5.43562 3.97975 5.15367 3.98834 4.89359 4.07961C4.63351 4.17088 4.40803 4.34036 4.24805 4.56481C4.08807 4.78926 4.00143 5.05769 4 5.33332V25.3333C4 26.804 5.196 28 6.66667 28H25.3333C26.804 28 28 26.804 28 25.3333V5.33332C27.9986 5.05769 27.9119 4.78926 27.752 4.56481C27.592 4.34036 27.3665 4.17088 27.1064 4.07961C26.8463 3.98834 26.5644 3.97975 26.2992 4.05501C26.0341 4.13027 25.7987 4.2857 25.6253 4.49999L21.3333 9.86532L17.0413 4.49999C16.5333 3.86799 15.4667 3.86799 14.9587 4.49999ZM6.66667 25.3333V22.6667H25.3347V25.3333H6.66667ZM20.292 12.8333C20.8 13.4667 21.868 13.4667 22.376 12.8333L25.3333 9.13465L25.3347 20H6.66667V9.13465L9.62533 12.8333C10.1333 13.4667 11.2013 13.4667 11.7093 12.8333L16 7.46799L20.292 12.8333Z"
        fill={color}
      />
    </svg>
  );
};
